<template>
    <v-row v-if="hasFilters && !isLoading">
        <v-col class="my-0 py-0">
            <v-menu  absolute v-for="(values, key) in groupedChips" :key="key" offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                    <v-chip v-on="on" v-bind="attrs" class="mr-1 mb-1" color="primary" text-color="white" pill>
                        {{ formatKey(key) }} ({{ values.length }})
                        <v-icon right class="ml-2" @click.stop="clearGroup(key)">mdi-close</v-icon>
                    </v-chip>
                </template>
                <v-list>
                    <v-list-item
                        v-for="(value) in values"
                        :key="`${key}-${value}`">
                        <v-list-item-title>
                            <v-chip
                                class="white--text mr-2"
                                color="primary">
                                <span class="fs-16">
                                  {{ displayName(key, value) }}
                                </span>
                                <v-icon
                                    right
                                    @click="removeFilter(key, value)">
                                    mdi-close
                                </v-icon>
                            </v-chip>
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        filters: {
            type: Object,
            required: true,
        },
        activeFilters: {
            type: Object,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        hasFilters() {
            return Object.values(this.activeFilters).some(val =>
                Array.isArray(val) ? val.length > 0 : !!val
            );
        },
        groupedChips() {
            const result = {};
            for (const [key, val] of Object.entries(this.activeFilters)) {
                if (Array.isArray(val)) {
                    if (val.length) result[key] = val;
                } else if (val) {
                    result[key] = [val];
                }
            }
            return result;
        },
    },
    methods: {
        removeFilter(key, value) {
            this.$emit('remove-single-filter', { key, value });
        },
        clearGroup(key) {
            this.$emit('clear-group', key);
        },
        formatKey(key) {
            return key
                .replace(/([A-Z])/g, ' $1')
                .replace(/^./, str => str.toUpperCase());
        },
        displayName(key, value){
            if (this.filters[key]) {
                const filter = this.filters[key].find(item => item.value === value);

                return filter ? filter.text : '';
            }

            return '';
        }
    },
};
</script>
